import { render, staticRenderFns } from "./RequestRetracted.vue?vue&type=template&id=38a8e4ca"
import script from "./RequestRetracted.vue?vue&type=script&lang=js"
export * from "./RequestRetracted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports